import React from 'react';
import { useTranslation } from 'react-i18next';
import { TableDropdown } from '@common/components/table';

type EvaluationActionsProps = {
  statusSubmitted: boolean;
  statusFinished: boolean;
  statusStarted: boolean;
  onWriteEvaluation: () => void;
  onFinishEvaluation: () => void;
  onViewResults: () => void;
};

export const EvaluationActions = ({
  statusSubmitted,
  statusFinished,
  statusStarted,
  onWriteEvaluation,
  onFinishEvaluation,
  onViewResults,
}: EvaluationActionsProps) => {
  const { t } = useTranslation();

  return (
    <TableDropdown>
      {statusStarted && (
        <TableDropdown.Item onClick={onWriteEvaluation}>
          {t('performance:write_evaluation')}
        </TableDropdown.Item>
      )}

      {statusSubmitted && (
        <TableDropdown.Item onClick={onFinishEvaluation}>
          {t('performance:finish_evaluation')}
        </TableDropdown.Item>
      )}

      {statusFinished && (
        <TableDropdown.Item onClick={onViewResults}>
          {t('performance:view_results')}
        </TableDropdown.Item>
      )}
    </TableDropdown>
  );
};
